/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_View_Logged_HintInputs */



/**
* | output |
* | --- |
* | "Opening it is logged: the player and the other organizers will see it." |
*
* @param {Decks_View_Logged_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_view_logged_hint = /** @type {((inputs?: Decks_View_Logged_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_View_Logged_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'ouverture est tracée : le joueur et les autres organisateurs le verront.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrirla queda registrado: el jugador y los demás organizadores lo verán.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A abertura fica registrada: o jogador e os outros organizadores vão ver.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'apertura viene registrata: il giocatore e gli altri organizzatori lo vedranno.")
	return /** @type {LocalizedString} */ ("Opening it is logged: the player and the other organizers will see it.")
});